import { Component, Inject, OnInit } from '@angular/core';
import { GruppeTier } from '../classes/gruppe-tier';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-gruppe-tier-bearbeiten-dialog',
    templateUrl: './gruppe-tier-bearbeiten-dialog.component.html',
    styleUrls: ['./gruppe-tier-bearbeiten-dialog.component.scss'],
})
export class GruppeTierBearbeitenDialogComponent implements OnInit {
    tier: GruppeTier;
    constructor(
        public dialogRef: MatDialogRef<GruppeTierBearbeitenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.tier = data.tier;
    }

    ngOnInit(): void {}
}
